import React from 'react'
import PropTypes from 'prop-types'
import styles from '../CheckVoucher.module.css'
import {
  Table, TableHead, TableBody, TableCell, TableRow, TableContainer
} from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import CancelIcon from '@material-ui/icons/Cancel';
import PrintIcon from '@material-ui/icons/Print';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Tooltip from '@material-ui/core/Tooltip'
import ReactToPrint from 'react-to-print'

class CheckVoucherContentDetailTab extends React.Component {

  getTotalDebit () {
    var totalDebit = 0
    if(this.props.checkVoucherContents.length>0){
      this.props.checkVoucherContents.map((content)=>{
        totalDebit = parseFloat(totalDebit) + parseFloat(content.amount_debit)
      })
    }
    return totalDebit
  }

  getTotalCredit () {
    var totalCredit = 0
    if(this.props.checkVoucherContents.length>0){
      this.props.checkVoucherContents.map((content)=>{
        totalCredit = parseFloat(totalCredit) + parseFloat(content.amount_credit)
      })
    }
    return totalCredit
  }

  render() {
    const printCheck = <ReactToPrint
      trigger={() =>
        <IconButton name="print_check">
          <CreditCardIcon color='primary' />
        </IconButton>
      }
      content={() => this.componentRef
      }
    />
    const pdfCheckToPrint = <div ref={(element) => (this.componentRef = element)} 
      style={{ 
        paddingTop: '48px', 
        paddingInline: '96px', 
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        gap: '12px',
        fontWeight: 600,
        fontSize: '16px'
      }}>
      <span style={{ alignSelf: 'flex-end' }}>{this.props.checkInfo.date}</span>
      <div style={{ 
        paddingInline: '48px', 
        display: 'flex', 
        flexDirection: 'row',
        justifyContent: 'space-between'
      }}>
        <span>***{this.props.checkInfo.payee}***</span>
        <span>***{this.props.checkInfo.amount}***</span>
      </div>
      <span style={{ paddingInline: '48px' }}>***{this.props.checkInfo.amountInWords}***</span>
    </div>
    const conditionfields = ['amount_credit','amount_debit']

    return (
      <div>
        <div className={this.props.forPrint ? styles.noDisplay : styles.checkDetailsHeader}>
          <div className={styles.groupButtonTab}>
            {this.props.checkVoucher.status === 'active' ? (
              <Tooltip title="Cancel Check Voucher" arrow>
                <IconButton name="cancel"
                  onClick={this.props.cancelCheckVoucher}
                >
                  <CancelIcon/>
                </IconButton>
              </Tooltip>
            ) :
              <Tooltip title="Active Check Voucher" arrow>
              <IconButton name="cancel_check"
              onClick={this.props.cancelCheckVoucher}
            >
              <CheckCircleOutlineIcon/>
            </IconButton>
              </Tooltip>}
            <Tooltip title="Print Check" arrow>
              <div>
                {printCheck}
              </div>
            </Tooltip>
            <Tooltip title="Print Check Voucher" arrow>
            <IconButton onClick={this.props.openPrint} color="primary">
              <PrintIcon/>
            </IconButton>
            </Tooltip>
          </div>
        </div>
        <TableContainer style={{maxHeight: '575px', position: 'relative'}}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <b> Account Code</b>
              </TableCell>
              <TableCell>
                <b>Account Title</b>
              </TableCell>
              <TableCell>
                <b>Remarks</b>
              </TableCell>
              <TableCell align="right">
                <b>Debit</b>
              </TableCell>
              <TableCell align="right">
                <b>Credit</b>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
          {
              conditionfields.map((field)=>(
                this.props.checkVoucherContents.sort(function (a, b) {
                  if (a.account.code.toLowerCase() < b.account.code.toLowerCase()) return -1;
                  if (a.account.code.toLowerCase() > b.account.code.toLowerCase()) return 1;
                  return 0;
                }).map((content) => (
                  content[field]==="0.0" &&
                  <TableRow key={content.id}>
                    <TableCell>
                      {content.account_code}
                    </TableCell>
                    <TableCell>
                      {content.account.name}
                    </TableCell>
                    <TableCell>
                      {content.remarks}
                    </TableCell>
                    <TableCell align="right">
                      {parseFloat(content.amount_debit).toLocaleString(navigator.language, {minimumFractionDigits: 2})}
                    </TableCell>
                    <TableCell align="right">
                      {parseFloat(content.amount_credit).toLocaleString(navigator.language, {minimumFractionDigits: 2})}
                    </TableCell>
                  </TableRow>
                ))
              ))
            }
            <TableRow>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell align="right"><b> Total :</b></TableCell>
              <TableCell align="right"><b>{this.getTotalDebit().toLocaleString(navigator.language, {minimumFractionDigits: 2})}</b></TableCell>
              <TableCell align="right"><b>{this.getTotalCredit().toLocaleString(navigator.language, {minimumFractionDigits: 2})}</b></TableCell>
            </TableRow>
          </TableBody>
        </Table>
        </TableContainer>
        <div style={{ display: 'none' }}>
          {pdfCheckToPrint}
        </div>
      </div>
    )
  }
}

export default CheckVoucherContentDetailTab

CheckVoucherContentDetailTab.propTypes = {
  classes: PropTypes.object,
  checkVoucher: PropTypes.object,
  checkVoucherContents: PropTypes.array,
  cancelCheckVoucher: PropTypes.func,
  openPrint: PropTypes.func,
  forPrint: PropTypes.bool,
  checkInfo: PropTypes.object
}
